import $ from 'cash-dom';
let instance = null;

class PodiumFilter {
	constructor() {
		if (instance) {
			return instance;
		}

		this._$topVendorsHolder = $('.top-vendors-holder');
		this._$vendorsList = $('.vendors-list');

		instance = this;
	}

	static getInstance() {
		if (!instance) {
			instance = new PodiumFilter();
		}

		return instance;
	}

	filter() {
		this._$topVendorsHolder.find('.top-vendor').addClass('hidden').removeClass('transparent');
		this._$topVendorsHolder.removeClass('one-vendor');

		this._$vendorsList.find('.ppc-single-vendor:not(.hidden)').each((i, vendor) => {
			let slug = $(vendor).attr('data-vendor-slug');

			if (slug) {
				$('.top-vendors-holder .top-vendor[data-vendor-slug="' + slug + '"]').removeClass('hidden');
			}

			if (i >= 1) {
				return false;
			}
		});

		let displayedTopVendorsNum = $('.top-vendors-holder .top-vendor:not(.hidden)').length;

		if (displayedTopVendorsNum === 1) {
			this._$topVendorsHolder.addClass('one-vendor');
		} else if (!displayedTopVendorsNum) {
			this._$topVendorsHolder.find('.top-vendor:first-of-type').addClass('transparent').removeClass('hidden');
		}
	}
}

export default PodiumFilter;
